// extracted by mini-css-extract-plugin
export default {"container":"ModalStaffEdit_container__LBuVg","form":"ModalStaffEdit_form__tgP5+","card":"ModalStaffEdit_card__trkJN","wrapperBox":"ModalStaffEdit_wrapperBox__SDqzB"};